/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.link-external\":\"Neliö, jossa on viistosti yläoikealle osoittava nuoli\"}");